export const TEMPLATE_FORM_NAME_FIELD_DATA_IDS = {
  base: 'template-form',
  nodeLogo: '',
  label: 'label'
};
